/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VwbGroupMember
 */
export interface VwbGroupMember {
    /**
     * Email of the group member
     * @type {string}
     * @memberof VwbGroupMember
     */
    email?: string;
    /**
     * Roles the member has on the group
     * @type {Array<string>}
     * @memberof VwbGroupMember
     */
    roles?: Array<string>;
}

/**
 * Check if a given object implements the VwbGroupMember interface.
 */
export function instanceOfVwbGroupMember(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VwbGroupMemberFromJSON(json: any): VwbGroupMember {
    return VwbGroupMemberFromJSONTyped(json, false);
}

export function VwbGroupMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbGroupMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'roles': !exists(json, 'roles') ? undefined : json['roles'],
    };
}

export function VwbGroupMemberToJSON(value?: VwbGroupMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'roles': value.roles,
    };
}

